import { injectable } from 'inversify';
import { MultipartUploadAdapter } from '@dealroadshow/file-uploader';
import finsightWebUrl from '@/finsight/infrastructure/finsightWebUrl';

@injectable()
export default class UploadAdapter extends MultipartUploadAdapter {
  constructor() {
    super({ url: finsightWebUrl.getUploadUrl() });
  }
}
